export default {
  props: {
    formModel: {
      type: Object,
      default: () => ({
        rules: {}
      })
    }
  }
}
